import React from 'react';
export default function ResetPassword() { return <div data-testid="reset-password-page">Reset Password</div>; }